(function() {

  // ========================= OCULTAR CAMPOS AL CARGAR =========================
  function ocultarTodos() {
    document.querySelectorAll(".campo").forEach(c => c.style.display = "none");
  }

  ocultarTodos();

  // ========================= MOSTRAR CAMPOS SEGÚN CATEGORÍA =========================
  function mostrarCampos(categoria) {
    ocultarTodos();

    const mostrar = (selector) => {
      const el = document.querySelector(selector);
      if(el) el.style.display = "block";
    };

    if(categoria === "brasier") {
      mostrar(".base-campo");
      mostrar(".busto-campo");
    } else if(categoria === "panty") {
      mostrar(".cadera-campo");
    } else if(categoria === "camisa") {
      mostrar(".busto-campo");
    } else if(categoria === "pantalon") {
      mostrar(".cadera-campo");
    } else if(categoria === "faja") {
      mostrar(".busto-campo");
      mostrar(".cintura-campo");
      mostrar(".cadera-campo");
    }
  }

  // ========================= LIMPIAR RESULTADO AL CAMBIAR CATEGORÍA =========================
  const categoriaSelect = document.getElementById("categoria");

  if(categoriaSelect) {
    categoriaSelect.addEventListener("change", function() {
      mostrarCampos(this.value);

      // Limpiar inputs y resultado al cambiar categoría
      document.querySelectorAll(".campo input").forEach(i => i.value = "");
      const resultado = document.getElementById("resultado");
      if(resultado) resultado.innerHTML = "";
    });
  }

  // ========================= FUNCIÓN CALCULAR =========================
  function calcular() {

    const categoria = document.getElementById("categoria").value;
    const resultadoHTML = document.getElementById("resultado");
    if(resultadoHTML) resultadoHTML.innerHTML = "";

    if(!categoria) return;

    /* ========================= BRASIERES Y TOPS DE BAÑO ========================= */
    if(categoria === "brasier") {

      let base  = parseInt(document.getElementById("base").value);
      let busto = parseInt(document.getElementById("busto").value);

      if(!base || !busto) return;

      const tabla = {
        32: { base:[69,73],   B:[86,90],   C:[88,92]   },
        34: { base:[74,78],   B:[91,95],   C:[93,97],   D:[95,99]   },
        36: { base:[79,84],   B:[96,100],  C:[98,102],  D:[100,104] },
        38: { base:[85,90],   B:[101,105], C:[103,107], D:[105,109] },
        40: { base:[91,96],   B:[106,110], C:[108,112], D:[110,114] },
        42: { base:[97,102],  B:[111,115], C:[113,117], D:[115,119] }
      };

      let posiblesCopas = [];

      for(let talla in tabla) {
        for(let copa in tabla[talla]) {
          if(copa === "base") continue;
          let [min, max] = tabla[talla][copa];
          if(busto >= min && busto <= max) {
            let distancia = Math.abs(busto - (min + max) / 2);
            posiblesCopas.push({ talla: parseInt(talla), copa, distancia });
          }
        }
      }

      if(posiblesCopas.length === 0) {
        resultadoHTML.innerHTML =
          "No encontramos una talla exacta para ti con las medidas ingresadas.<br>" +
          "Escríbenos para brindarte asesoría personalizada.<br><br>" +
          "<a href='https://wa.me/573122704253?text=Quiero%20asesoria%20para%20comprar%20por%20WhatsApp' target='_blank' class='whatsapp-link'>WhatsApp 312 270 4253</a>";
        return;
      }

      posiblesCopas.sort((a, b) => a.distancia - b.distancia);
      let mejorCopa = posiblesCopas.find(p => p.copa === "B") || posiblesCopas[0];

      let tallaMasCercana = null;
      let menorDistanciaBase = 999;

      for(let talla in tabla) {
        let [baseMin, baseMax] = tabla[talla].base;
        let distanciaBase = Math.abs(base - (baseMin + baseMax) / 2);
        if(distanciaBase < menorDistanciaBase) {
          menorDistanciaBase = distanciaBase;
          tallaMasCercana = talla;
        }
      }

      resultadoHTML.innerHTML =
        "Tu talla recomendada es <br><strong>" + tallaMasCercana + mejorCopa.copa + "</strong>.<br>" +
        "Priorizamos la copa para garantizar un ajuste perfecto. " +
        "Nuestros brasieres cuentan con 4 niveles de ajuste que permiten adaptar el contorno de la base de forma cómoda y precisa.";
    }

    /* ========================= PANTIES ========================= */
    else if(categoria === "panty") {

      let cadera = parseInt(document.getElementById("cadera").value);
      if(!cadera) return;

      const tabla = [
        { talla: "S",   min: 86,  max: 95  },
        { talla: "M",   min: 96,  max: 105 },
        { talla: "L",   min: 106, max: 115 },
        { talla: "XL",  min: 116, max: 125 },
        { talla: "XXL", min: 126, max: 135 },
      ];

      const match = tabla.find(r => cadera >= r.min && cadera <= r.max);
      resultadoHTML.innerHTML = match
        ? "Tu talla recomendada es <br><strong>" + match.talla + "</strong>."
        : "No encontramos una talla exacta para ti con las medidas ingresadas.<br>" +
          "Escríbenos para brindarte asesoría personalizada.<br><br>" +
          "<a href='https://wa.me/573122704253?text=Quiero%20asesoria%20para%20comprar%20por%20WhatsApp' target='_blank' class='whatsapp-link'>WhatsApp 312 270 4253</a>";
    }

    /* ========================= CAMISAS PIJAMA ========================= */
    else if(categoria === "camisa") {

      let busto = parseInt(document.getElementById("busto").value);
      if(!busto) return;

      const tabla = [
        { talla: "S",  min: 86,  max: 90  },
        { talla: "M",  min: 91,  max: 95  },
        { talla: "L",  min: 96,  max: 100 },
        { talla: "XL", min: 101, max: 105 },
      ];

      const match = tabla.find(r => busto >= r.min && busto <= r.max);
      resultadoHTML.innerHTML = match
        ? "Tu talla recomendada es <br><strong>" + match.talla + "</strong>."
        : "No encontramos una talla exacta para ti con las medidas ingresadas.<br>" +
          "Escríbenos para brindarte asesoría personalizada.<br><br>" +
          "<a href='https://wa.me/573122704253?text=Quiero%20asesoria%20para%20comprar%20por%20WhatsApp' target='_blank' class='whatsapp-link'>WhatsApp 312 270 4253</a>";
    }

    /* ========================= PANTALONES PIJAMA ========================= */
    else if(categoria === "pantalon") {

      let cadera = parseInt(document.getElementById("cadera").value);
      if(!cadera) return;

      const tabla = [
        { talla: "S",  min: 86,  max: 95  },
        { talla: "M",  min: 96,  max: 105 },
        { talla: "L",  min: 106, max: 115 },
        { talla: "XL", min: 116, max: 125 },
      ];

      const match = tabla.find(r => cadera >= r.min && cadera <= r.max);
      resultadoHTML.innerHTML = match
        ? "Tu talla recomendada es <br><strong>" + match.talla + "</strong>."
        : "No encontramos una talla exacta para ti con las medidas ingresadas.<br>" +
          "Escríbenos para brindarte asesoría personalizada.<br><br>" +
          "<a href='https://wa.me/573122704253?text=Quiero%20asesoria%20para%20comprar%20por%20WhatsApp' target='_blank' class='whatsapp-link'>WhatsApp 312 270 4253</a>";
    }

    /* ========================= FAJAS ========================= */
    else if(categoria === "faja") {

      let busto   = parseInt(document.getElementById("busto").value);
      let cintura = parseInt(document.getElementById("cintura").value);
      let cadera  = parseInt(document.getElementById("cadera").value);

      if(!busto || !cintura || !cadera) return;

      const tallasPorBusto = [
        { talla: "S / 32B",   min: 86,  max: 90  },
        { talla: "M / 34B",   min: 91,  max: 95  },
        { talla: "L / 36B",   min: 96,  max: 100 },
        { talla: "XL / 38B",  min: 101, max: 105 },
        { talla: "XXL / 40B", min: 106, max: 110 },
      ];

      const tallasPorCintura = [
        { talla: "S / 32B",   min: 70, max: 75 },
        { talla: "M / 34B",   min: 76, max: 80 },
        { talla: "L / 36B",   min: 81, max: 85 },
        { talla: "XL / 38B",  min: 86, max: 90 },
        { talla: "XXL / 40B", min: 91, max: 95 },
      ];

      const tallasPorCadera = [
        { talla: "S / 32B",   min: 86,  max: 95  },
        { talla: "M / 34B",   min: 96,  max: 105 },
        { talla: "L / 36B",   min: 106, max: 115 },
        { talla: "XL / 38B",  min: 116, max: 125 },
        { talla: "XXL / 40B", min: 126, max: 135 },
      ];

      const getTalla = (valor, tabla) => {
        const match = tabla.find(r => valor >= r.min && valor <= r.max);
        return match ? match.talla : null;
      };

      const tallaBusto   = getTalla(busto, tallasPorBusto);
      const tallaCintura = getTalla(cintura, tallasPorCintura);
      const tallaCadera  = getTalla(cadera, tallasPorCadera);

      const votos = [tallaBusto, tallaCintura, tallaCadera].filter(Boolean);

      if(votos.length === 0) {
        resultadoHTML.innerHTML = "No encontramos una talla exacta para ti con las medidas ingresadas.<br>" +
          "Escríbenos para brindarte asesoría personalizada.<br><br>" +
          "<a href='https://wa.me/573122704253?text=Quiero%20asesoria%20para%20comprar%20por%20WhatsApp' target='_blank' class='whatsapp-link'>WhatsApp 312 270 4253</a>";
        return;
      }

      const conteo = {};
      votos.forEach(t => { conteo[t] = (conteo[t] || 0) + 1; });

      const tallaFinal = votos.reduce((mejor, t) =>
        conteo[t] > conteo[mejor] ? t : mejor
      );

      resultadoHTML.innerHTML = `Tu talla recomendada es <br><strong>${tallaFinal}</strong>.`;
    }
  }

  // ========================= RECALCULAR AL CAMBIAR UN INPUT =========================
  document.querySelectorAll(".campo input").forEach(input => {
    input.addEventListener("input", calcular);
  });

})();